export { default } from './Summary'

export { HEADING_TYPE } from './Summary.const'
